<template>
  <div v-if="lazySMSFieldsData !== null">
    <v-combobox
      v-model="lazySMSFieldsData.receivers"
      :items="receiverItems"
      :search-input.sync="search"
      :hide-no-data="!search"
      :rules="[allPhoneValid, formRules.required]"
      :hint="$t('sms.help.internationalPhone')"
      :label="translateWithRequired('sms.label.sendTo')"
      @change="receiversChanged"
      hide-selected
      multiple
      small-chips
      solo
      outlined
      required
    >
      <template v-slot:no-data>
        <v-list-item v-if="isValidPhone(search)">
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("user.prompt.noResultsMatching") }} "<strong>{{
                search
              }}</strong
              >". {{ $t("user.prompt.pressEnter.press") }}
              <kbd>{{ $t("user.prompt.pressEnter.enterKey") }}</kbd>
              {{ $t("user.prompt.pressEnter.toCreateNew") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:selection="{ item, attrs, selected }">
        <v-chip
          v-bind="attrs"
          :color="isValidPhone(item.value ? item.value : item) ? '' : 'error'"
          :input-value="selected"
          small
          label
        >
          <template v-if="item.text">
            {{ item.text }}
          </template>
          <template v-else>
            {{ item }}
          </template>
        </v-chip>
      </template>
    </v-combobox>
    <v-textarea
      v-model="lazySMSFieldsData.message"
      :label="translateWithRequired('sms.label.message')"
      :rules="[formRules.required]"
      @change="emitSMSFieldsDataUpdate"
      counter
      outlined
      required
    ></v-textarea>
    <v-text-field
      v-model="lazySMSFieldsData.signature"
      :label="translateWithRequired('sms.label.signature')"
      :rules="[formRules.required]"
      @change="emitSMSFieldsDataUpdate"
    >
    </v-text-field>
  </div>
</template>

<script lang="ts">
import Component from "vue-class-component";
import Vue from "vue";
import { Emit, Prop, Watch } from "vue-property-decorator";
import { SMSFieldsData } from "@/api/models/sms/sms-fields-data";
import { plainToInstance } from "class-transformer";
import { formRules } from "@/utils/form-rules";
import { translateWithRequired } from "@/utils/transform-translate";
import { ReceiverItem } from "@/api/models/sms/type/receiver-item.interface";

@Component
export default class SMSFields extends Vue {
  @Prop({ type: SMSFieldsData, required: true })
  public readonly SMSFieldsData!: SMSFieldsData;

  @Prop({ type: Array, required: false })
  public readonly receiverItems!: ReceiverItem[];

  @Watch("SMSFieldsData", { immediate: true })
  SMSFieldsChanged(SMSFields: SMSFieldsData | null) {
    if (SMSFields) {
      this.lazySMSFieldsData = plainToInstance(SMSFieldsData, SMSFields);
    } else {
      this.lazySMSFieldsData = null;
    }
  }

  @Emit("update:SMSFieldsData")
  public emitSMSFieldsDataUpdate() {
    return plainToInstance(SMSFieldsData, { ...this.lazySMSFieldsData });
  }

  public lazySMSFieldsData: SMSFieldsData | null = null;
  public search: string | null = null;
  public invalidPhones: string[] = [];
  public formRules = formRules;
  public translateWithRequired = translateWithRequired;

  public receiversChanged(values: (ReceiverItem | string)[]) {
    this.invalidPhones = [];
    for (const value of values) {
      if (
        typeof value === "string" &&
        formRules.internationalPhone(value) !== true
      ) {
        this.invalidPhones.push(value);
      }
    }
    this.emitSMSFieldsDataUpdate();
  }

  public isValidPhone(phone: string) {
    return phone && formRules.internationalPhone(phone) === true;
  }

  public allPhoneValid() {
    return this.invalidPhones.length === 0 || this.$tc("rules.phone");
  }
}
</script>
